module.exports = __webpack_public_path__ + "static/media/KV04.a7ad6b5b.jpg";